import { CaretDownFilled, FilterOutlined, SearchOutlined } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Button,
  Form,
  Input,
  Row,
  Select,
  Space,
  Cascader as Cascaded,
  Dropdown,
  Menu,
  Checkbox,
} from 'antd'
import moment from 'moment'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectEdition, selectInsuranceArray, selectUserId } from '../../../app/applicationSlice'
import { RootDispatch } from '../../../app/store'
import {
  DateRangeFieldName,
  DateRangeType,
  DateSelect,
  getDateRange,
  TJFXTime,
} from '../../../compnents/form/DateSelect'
import { User } from '../../../models/user'
import { ThemeContext } from '../../../theme/ThemeContext'
import { getFullUserList } from '../../completion/completionSlice'
import { getFullDoctorList } from '../../registration/list/registrationSlice'
import styles from '../transactionQueryTab.module.css'
import { getCounselor, getPatientOptionsAsync } from '../../A-toothModule/toothHome/toothHomeSlice'
import { getCheckPermissionAsync } from '../../FunctionSetting/dataPermission/dataPermissionSlice'
import { SJQXChecks } from '../../../models/dataPersion'
import { FilterColumn } from '../../../compnents/filterForm/filterForm'

export const Query = (props: {
  selectedTab?: any
  loading?: any
  filterColumn?: any
  filterSelectList?: any
  alertMessage: () => void
  submitPageList?: (selectedColumns: string[]) => void
  onValueChange: (params: any) => void
}): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const theme = useContext(ThemeContext)

  const userId = useSelector(selectUserId)

  const hisVersion = useSelector(selectEdition) //his版本 0通用 1口腔

  const [form] = Form.useForm()

  const insuranceArray = useSelector(selectInsuranceArray)

  const [doctors, setDoctors] = useState<any>([])

  const [users, setUsers] = useState<User[]>([])

  const [current, setCurrent] = useState<any>()

  const [isInTimeRange, setIsInTimeRange] = useState(false)

  const [selectedColumns, setSelectedColumns] = useState<string[]>([])

  const [YSCKData, setYSCKData] = useState<any>('')

  // 筛选中默认勾选的值
  const filterColumnSelectList: any = props?.filterSelectList

  const [treatmentAssistantDoctorList, setTreatmentAssistantDoctorList] = useState<any[]>() //  助理医师数据

  const [classificationList, setClassificationList] = useState<any>() //自定义患者来源数据

  const checkTimeRange = () => {
    const now = moment()
    const currentHour = now.hours()

    // 判断当前时间是否在给定的时间段内
    if (
      (currentHour >= 10 && currentHour < 12) ||
      (currentHour === 12 && now.minutes() === 0) ||
      (currentHour >= 14 && currentHour < 16) ||
      (currentHour >= 19 && currentHour <= 23) ||
      (currentHour >= 0 && currentHour < 6)
    ) {
      setIsInTimeRange(true)
    } else {
      setIsInTimeRange(false)
    }
  }

  useEffect(() => {
    checkTimeRange()
    getCheckPermissionFn()
    if (hisVersion == 1) {
      getTreatmentAssistantDoctorFn()
    }
    // 获取患者来源字典
    dispatch(getPatientOptionsAsync({ types: '0,1,2' }))
      .then(unwrapResult)
      .then((res: any) => {
        const findItems = (type: string) => {
          return res ? res?.find((t: any) => t.type == type)?.items?.map((v: any) => {
            return {
              name: v.context,
              value: v.sortNo,
            }
          }) : []
        }
        setClassificationList({
          sourceList: findItems('1'),
        })
      })
  }, [])

  // 获取医生查看交易查询权限
  const getCheckPermissionFn = () => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.YSCKJYCX }))
      .then(unwrapResult)
      .then((res:any) => {
        setYSCKData(res)
        if(res == 1){
          form.setFieldsValue({
          treatmentDoctorId: undefined,
        })
        }
      })
  }

  // 获取助理医师
  const getTreatmentAssistantDoctorFn = () => {
    //获取咨询师
    dispatch(
      getCounselor({
        current: 1,
        size: 100,
        stationCategory: 8,
      })
    )
      .then(unwrapResult)
      .then(({ records }) =>
        setTreatmentAssistantDoctorList(
          records
            .filter((v: any) => v.kssxbz != 1)
            .filter((v: any) => v.state == 1)
        )
      )
  }


  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_jiaoyichaxun') || '{}'
  )

  useEffect(() => {
    const [head, tail] = getDateRange(DateRangeType.Today)

    if (
      Object.keys(storageParams).length &&
      props.selectedTab == storageParams.selectedTab
    ) {
      form.setFieldsValue({
        ...storageParams,
        treatmentDoctorId: YSCKData == 1 ? userId : storageParams?.treatmentDoctorId,
        timeHead: storageParams?.registrationTimeHead || head,
        timeTail: storageParams?.registrationTimeTail || tail,
        [DateRangeFieldName]: storageParams?._dateRange || DateRangeType.Today,
      })
    } else {
      form.setFieldsValue({
        _dateRange: 0,
        registrationTimeHead: head,
        registrationTimeTail: tail,
      })
    }

    form.submit()
  }, [YSCKData])

  const refresh = () => {
    props.onValueChange({
      ...storageParams,
      treatmentDoctorId: YSCKData == 1 ? undefined : storageParams?.treatmentDoctorId,
      ...form.getFieldsValue(),
      selectedTab: props.selectedTab,
      current: current || 1,
    })
  }

  useEffect(() => {
    dispatch(getFullDoctorList())
      .then(unwrapResult)
      .then((ds) => setDoctors(ds))
      .catch(() => {
        // do nothing
      })
  }, [])

  useEffect(() => {
    dispatch(getFullUserList({ current: 1, size: 1000, state: 1 }))
      .then(unwrapResult)
      .then((users) => setUsers(users))
      .catch(() => {
        // do nothing.
      })
  }, [])

  return (
    <Form
      className={styles.formStyle}
      form={form}
      onFinish={(values) => {
        const data =
          props.selectedTab == storageParams.selectedTab ? storageParams : {}
        props.onValueChange({
          ...data,
          ...values,
          current: current,
          selectedTab: props.selectedTab,
        })
      }}
    >
      <Row style={{ marginBottom: 10 }} justify='space-between'>
        <Space wrap>
          <Form.Item noStyle name='param'>
            <Input
              autoComplete='off'
              maxLength={20}
              prefix={<SearchOutlined />}
              placeholder='患者姓名/手机号/助记码'
              style={{ width: '14rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            />
          </Form.Item>
          {insuranceArray && insuranceArray.length !== 0 && (
            <Form.Item name='insuranceCode' noStyle>
              <Select
                placeholder='险种类型'
                style={{ width: '7rem' }}
                allowClear
                onChange={() => {
                  setCurrent(1)
                  refresh()
                }}
              >
                <Select.Option value={''}>全部</Select.Option>
                <Select.Option value={'ZIFEI'}>自费</Select.Option>
                <Select.Option value={'0'}>本地</Select.Option>
                <Select.Option value={'1'}>省内异地</Select.Option>
                <Select.Option value={'2'}>省外异地</Select.Option>
                <Select.Option value={'3'}>省医保</Select.Option>
                {/* {insuranceArray.map((v) => (
                  <Select.Option value={v.insuranceCode} key={v.id}>
                    {v.insuranceName}
                  </Select.Option>
                ))} */}
              </Select>
            </Form.Item>
          )}
          <Form.Item name='orderSource' noStyle>
            <Select
              placeholder='收费标志'
              style={{ width: '7rem' }}
              allowClear
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              <Select.Option value={1}>门诊</Select.Option>
              <Select.Option value={2}>零售</Select.Option>
              <Select.Option value={3}>挂号</Select.Option>
            </Select>
          </Form.Item>
          <Form.Item name='patientSource' noStyle>
            <Select
              allowClear
              placeholder='患者来源'
              style={{ width: '7rem' }}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              {classificationList?.sourceList.map((v: any) => {
                return (
                  <Select.Option key={v.name} value={v.name}>
                    {v.name}
                  </Select.Option>
                )
              })}
            </Select>
          </Form.Item>
          <Form.Item name='treatmentDoctorId' noStyle>
            <Select
              disabled={YSCKData == 1 ? true : false}
              allowClear
              placeholder='接诊医生'
              style={{
                width: '7rem',
              }}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              {doctors.map((d: any) => (
                <Select.Option key={d.id} value={d.id}>
                  {d.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          {hisVersion == 1 ? <>
            <Form.Item name='treatmentAssistantDoctorId' noStyle>
              <Select
                allowClear
                placeholder='助理医师'
                style={{
                  width: '7rem',
                }}
                onChange={() => {
                  setCurrent(1)
                  refresh()
                }}
              >
                {treatmentAssistantDoctorList?.map((d: any) => (
                  <Select.Option key={d.id} value={d.id}>
                    {d.realname}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item></> : <></>}
          <Form.Item noStyle name='operateUser'>
            <Select
              placeholder='收款人'
              allowClear
              style={{ width: '7rem' }}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
              showSearch
            >
              {users.map((u) => (
                <Select.Option key={u.id} value={u.id}>
                  {u.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              placeholder='结算状态'
              style={{ width: '7rem' }}
              allowClear
              // suffixIcon={<CaretDownFilled />}
              onChange={() => {
                setCurrent(1)
                refresh()
              }}
            >
              <Select.Option key={3} value={3}>
                已收费
              </Select.Option>
              <Select.Option key={5} value={5}>
                已退费
              </Select.Option>
              <Select.Option key={7} value={7}>
                欠费中
              </Select.Option>
            </Select>
          </Form.Item>

          <DateSelect
            allowClear={false}
            style={{ width: '7rem' }}
            labelPrefix=''
            namePrefix='time'
            options={TJFXTime}
            placeholder='时间范围-时间'
            initialValue={DateRangeType.Today}
            onChange={(e) => {
              if (e != 6) {
                refresh()
              }
            }}
          />
          <Button
            loading={props?.loading}
            type='primary'
            onClick={() => {
              setCurrent(1)
              refresh()
            }}
          >
            查询
          </Button>
          <FilterColumn
            filterColumn={props?.filterColumn}
            filterSelectList={props?.filterSelectList}
            // 筛选列变化时的数据
            onColumnVisibilityChange={(v: any) => {
              // 以 filterColumn 的顺序为基准，用 v 中的字段顺序重排，并保留 filterColumn 的 visible 状态
              const sortList = props?.filterColumn?.map((val: any) => {
                return {
                  ...val,
                  visible: v?.includes(val.field)
                }
              })
              props?.submitPageList && props?.submitPageList(sortList)
            }}
          />
          {isInTimeRange ? (
            <div
              style={{
                opacity: 0,
                cursor: 'pointer',
                width: '10px',
                height: '30px',
              }}
              onDoubleClick={() => {
                props?.alertMessage && props?.alertMessage()
              }}
            ></div>
          ) : (
            <></>
          )}
        </Space>
      </Row>
    </Form>
  )
}
